// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"TableHeader_tableHeader__18ut9"};